import React from "react";
import { t } from "../../utils/i18n";

const ReceiveModal = ({ token, tokenAddress, tokenImage, closeModal }) => (
  <div
    className="modal fade"
    id="tokenAddressModal"
    tabIndex="-1"
    aria-labelledby="tokenAddressModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header mb-4">
          <h5 className="modal-title" id="tokenAddressModalLabel"></h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label={t("wallets.receive_modal.close")}
            onClick={() => closeModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body" data-controller="clipboard">
          <div className="row">
            <div className="col-md-12">
              <p className="font-weight-bold">
              <span className="text-warning ">{t("wallets.receive_modal.use_address_only")}</span> <img src={token?.image} width="30" height="30" /> {token.name}.
              </p>
              <p className="text-warning">
                {t("wallets.receive_modal.convert_note", { name: token.name })}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <label className="font-0_9 font-weight-bold">
                {t("wallets.receive_modal.your_address", { name: token.name })}
              </label>
              <input
                className="form-control border-0 font-1_0 pt-0 user-select-all"
                data-clipboard-target="source"
                type="text"
                value={tokenAddress}
                readOnly
              />
              <hr />
              <label className="font-0_8">{t("wallets.receive_modal.copy_address").split("%{icon}")[0]}<img src={token?.image} width="20" height="20" />{t("wallets.receive_modal.copy_address").split("%{icon}")[1]}</label>
              <div className="input-group-append">
                <div className="input-group-text border-0">
                  <button
                    title={t("wallets.receive_modal.copy_to_clipboard")}
                    className="btn btn-secondary"
                    data-action="clipboard#copy"
                  >
                    <i className="fa fa-clipboard fa-2x fa-fw"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <label className="font-0_8">{t("wallets.receive_modal.scan_address").split("%{icon}")[0]}<img src={token?.image} width="20" height="20" />{t("wallets.receive_modal.scan_address").split("%{icon}")[1]}</label>
              <br />
              {tokenImage && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: tokenImage
                  }}
                />
              )}
              <br />
            </div>
            <div className="col-md-12">
              <div className="font-0_8 text-muted pt-4 ml-3">
                <p>
                  <strong> {t("wallets.receive_modal.only_send", { label: token.label })}</strong>.
                  <br />
                  {t("wallets.receive_modal.loss_warning", { chain: token.value, label: token.label })}
                </p>
              </div>
            </div>
          </div>
          <div className="modal-footer ml-auto border-0">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              {t("wallets.receive_modal.close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ReceiveModal;
